import { useParams, useNavigate } from "react-router-dom";
import React from "react";
import { usePermission } from "../../../permissions/usePermission";
import AppHeader from "../../LandingPage/AppHeader/AppHeader";
import LandingPageFooter from "../../LandingPage/LandingPageFooter/FooterForLandingPage";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  Divider,
  Button,
  Stack,
  Link,
} from "@mui/material";
import { styled } from "@mui/system";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import PhotoOutlinedIcon from "@mui/icons-material/PhotoOutlined";
import MediaDocumentsTabs from "./MediaDocumentsTabs";

import data from "../../../utils/Program_Dashboard_JsonData/SingleProgramsData.json";

// Styled Components for consistent padding and styling
const StyledCard = styled(Card)({
  height: "100%",
});

const StyledTitle = styled(Typography)({
  textAlign: "center",
  backgroundColor: "red",
});

const SingleProgDetails = () => {
  const { programName } = useParams();
  const navigate = useNavigate();
  const { canByKey } = usePermission();
  const canViewProgramDashboard = canByKey("CORE_PROGRAM_VIEW");

  const programObj = data.find((p) =>
    p.children.some((child) => child.title === programName)
  );
  const subProgram = programObj?.children.find(
    (child) => child.title === programName
  );

  const handleNav = () => {
    if (canViewProgramDashboard) {
      navigate("/programManager/programdashboard");
    } else {
      navigate("/contact-admin");
    }
  };

  if (!subProgram) {
    return (
      <>
        <Box
          sx={{
            padding: "40px",
            textAlign: "center",
            height: "80vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <PhotoOutlinedIcon sx={{ fontSize: 60, color: "grey.400" }} />
          <Typography variant="h6" sx={{ mt: 2, color: "text.secondary" }}>
            No details found for this program.
          </Typography>
        </Box>
        <LandingPageFooter />
      </>
    );
  }

  const stories = [
    {
      title: "Asha's Journey",
      text: '"YouWaah gave me the confidence to start my own business and lead my community."',
      img: "https://lh3.googleusercontent.com/aida-public/AB6AXuBWV_zi2TJfCa7NQYQzZj_KeR2Lfz1n5mLk_8nchfPF-wKOE7GDjAJgVTE9OP65C6lBYNxMZWAswaroVpRIEQqH1LJhoK8nGLbN3_8NNHUo9bpQIeOQdz-YnHv4ubMHu8pBYxwDbCuKP6mKll3-dQ0ECyDSYFai62Zt_9q6A04OnQqACYVhuAR5cXtEjoxGKBr7XSkzAT_MjSaDPJVzOvGLQ8cyLJOCm4uJWjpfDtiNbGsYLt5i5ysGSYgUm2n8frERp_oA_n35QTL9",
    },
    {
      title: "Rohan's Innovation",
      text: '"The mentorship I received was invaluable. I developed a tech solution for local farmers."',
      img: "https://lh3.googleusercontent.com/aida-public/AB6AXuBplVCdhWFzzjBgT_cXlauuXBs5hVyicYV43z-fGTJTIBkiBBIr_mIIyT-zmbbb_24YaLQcIbLgDgZ1APzkWLJdc2gj-WO4eBCRWuWphDssnFJVLJ90fbExv7F6fGsF1kbwqAEX3Zr90CklbIY3r4zRcqGj6tDET3Id1dp358RQAz3CThw9rhP2mdHNBjYRR5pe3cSyaCnjapJMBZzxTeQJavWd-ByuLqolsGrd7l2kOKgiofiGyYVbdP_rqdxnHKUKIJNfH2hcgNXY",
    },
    {
      title: "Community Impact",
      text: '"We organized a cleanliness drive that brought our entire neighborhood together."',
      img: "https://lh3.googleusercontent.com/aida-public/AB6AXuALeohGSEFAsSnrsYkMBcKL9kTSEHS2nIvBpLuzyCvypSkM2HNu185Ru-lnwuy2u9udELxDR55ntkFckITBU2Fkobt6cyne1xaRq452pFiw5fJ-qG54gO8TVVC37qw-8vwDdz1GoG90aYGynN8NUfU5QluD2NzWtb2dIxquUgfTMoZOj7x1vpZtJR0ta2TIEFNiE3UCVvpdsMBZMbCWO4uHGi18seLtDtxQY0ogbni7ernnaHP4k5dDu_ikJVIDL2aEz27ySYEkXheE",
    },
    {
      title: "Priya's Leadership",
      text: '"I learned to use my voice for change, and now I represent youth on our local council."',
      img: "https://lh3.googleusercontent.com/aida-public/AB6AXuCK7SPoFC7EornvHC2BxfAijDoCgSamDMaIy5266OwDgxfzryP_gX9n6-cDMG8_5y7vxAn1xtZ6UpEqkQuU5wzEFyqnYqTJHQQbX6BwL0B 97MZA0WsaZsC83ZmIUIwKDBYIhMIAattc2PAGEP5iL0ePXscDfx7en7t7Jbw0hkWY78dli-ypo7sAzoYJe8IAGlo85o2midnNnxxCQcideIKOEMQ-rco6LUE73WlcWahdstWbH3cGwHILC2YOTd9KY2xq3Uk-O_pyM",
    },
  ];

  return (
    <>
      {/* Main Title Section */}
      <div style={{ position: "relative" }}>
        {/* Banner Image */}
        <img
          src="https://lh3.googleusercontent.com/aida-public/AB6AXuA_uH8r8VU01AbISa0iGuDGrEBjim87nR-OIYcDmDw6ZuyFCebDV9n-47g50mly7sZMBWsQ_FiqD0rfvrPnk9xItKFo_swI-xljKi1075BjAw7wSg2X-uEhXiagDEeaYORLfCngTXacceaAfPvk4wyRSPgcS8Faw_jqwQiBg6bzagI3xLmihpfBgSSw_kJbyqpqtfxLp7fkSjHOBYl0t4lRjdkn8tb7kF5BzUXxYWEFk1BVzyx9vje0tbzPQvg35V6vI6T9So6NpcJb"
          alt="Program Banner"
          style={{
            width: "100%",
            height: "250px",
            objectFit: "cover",
            borderRadius: "8px",
          }}
        />

        {/* Overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.2))",
            borderRadius: "12px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "flex-start",
            padding: "2rem",
            color: "white",
          }}
        >
          <h1
            style={{
              fontSize: "2.5rem",
              fontWeight: "700",
              marginBottom: "0.2rem",
              color: "white",
            }}
          >
            {subProgram.title} Program
          </h1>
          <p style={{ fontSize: "1.5rem" }}>
            Category - {programObj?.title}
          </p>

          {/* --- Description --- */}
          <Typography
            sx={{
              fontSize: "1rem",
              color: "#fff",
              lineHeight: 1,
            }}
          >
            Description - {subProgram.description || "No description available."}
          </Typography>

          {/* {isAdmin && (
              <button
                onClick={handleNav}
                style={{
                  backgroundColor: "#6100dc",
                  color: "white",
                  padding: "0.8rem",
                  border: "none",
                  borderRadius: "8px",
                  fontWeight: "600",
                  cursor: "pointer",
                  boxShadow: "0 4px 10px rgba(97, 0, 220, 0.3)",
                  transition: "0.3s",
                }}
                onMouseOver={(e) =>
                  (e.target.style.backgroundColor = "#4e00b5")
                }
                onMouseOut={(e) => (e.target.style.backgroundColor = "#6100dc")}
              >
                ⚙️ Manage this Program
              </button>
            )} */}
        </div>

      </div>
      <Box
        sx={{
          padding: "20px",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        {/* <Box sx={{ marginBottom: "20px" }}>
          
        </Box> */}

        <Box
          sx={{
            width: "100%",
            background: "#fff",
            borderRadius: "12px",
            // boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
            border: "1px solid #eee",
            p: 3,
            mb: 3,
          }}
        >
          {/* --- Program Title --- */}
          {/* <Typography
            variant="h5"
            sx={{ fontWeight: 700, color: "#222", mb: 1 }}
          >
            {subProgram?.title || "Program Name"}
          </Typography> */}

          {/* --- Capsule Subboxes --- */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "nowrap",
              gap: 2,
              overflowX: "auto",
              pb: 1,
              justifyContent: "space-around"
            }}
          >
            {/* --- Program Kits --- */}
            {/* <Box
              sx={{
                width: 200,
                height: 100,
                background: "#f8f4ff",
                borderRadius: "8px",
                border: "1px solid #e0d7ff",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
              }}
            >
              <Typography sx={{ fontWeight: 600, color: "#6100dc" }}>
                Program Kits
              </Typography>
              <Typography sx={{ color: "#666", fontSize: "0.9rem" }}>
                {subProgram.programKits?.length || 0} items
              </Typography>
            </Box> */}

            {/* --- Promotional Kits --- */}
            {/* <Box
              sx={{
                width: 200,
                height: 100,
                background: "#fff7ef",
                borderRadius: "8px",
                border: "1px solid #ffe0b3",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
              }}
            >
              <Typography sx={{ fontWeight: 600, color: "#e69500" }}>
                Promotional Kits
              </Typography>
              <Typography sx={{ color: "#666", fontSize: "0.9rem" }}>
                {subProgram.promotionalKits?.length || 0} items
              </Typography>
            </Box> */}

            {/* --- Key Dates --- */}
            <Box
              sx={{
                width: 200,
                height: 100,
                background: "#eef9ff",
                borderRadius: "8px",
                border: "1px solid #cce7ff",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                // boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
              }}
            >
              <Typography sx={{ fontWeight: 600, color: "#0074e8" }}>
                Key Dates
              </Typography>
              <Typography sx={{ color: "#666", fontSize: "0.9rem" }}>
                {subProgram.startDate
                  ? `${subProgram.startDate} → ${subProgram.endDate}`
                  : <b>12th Nov 2024</b>}
              </Typography>
            </Box>


            <Box
              sx={{
                width: 200,
                height: 100,
                background: "#f3e8ff",
                borderRadius: "8px",
                border: "1px solid #e0caff",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
              }}
            >
              <Typography sx={{ fontWeight: 600, color: "#7a00c2" }}>
                Total Participants
              </Typography>
              <Typography sx={{ color: "#444", fontSize: "1.2rem", fontWeight: 700 }}>
                {subProgram.participants || 927}
              </Typography>
            </Box>


            <Box
              sx={{
                width: 200,
                height: 100,
                background: "#e8f7ff",
                borderRadius: "8px",
                border: "1px solid #c8eaff",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
              }}
            >
              <Typography sx={{ fontWeight: 600, color: "#0085d1" }}>
                Districts Participated
              </Typography>
              <Typography sx={{ color: "#444", fontSize: "1.2rem", fontWeight: 700 }}>
                {subProgram.districts || 121}
              </Typography>
            </Box>


            <Box
              sx={{
                width: 200,
                height: 100,
                background: "#e9ffe8",
                borderRadius: "8px",
                border: "1px solid #c9f7c7",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
              }}
            >
              <Typography sx={{ fontWeight: 600, color: "#0b8a23" }}>
                States Participated
              </Typography>
              <Typography sx={{ color: "#444", fontSize: "1.2rem", fontWeight: 700 }}>
                {subProgram.states || 11}
              </Typography>
            </Box>


            <Box
              sx={{
                width: 200,
                height: 100,
                background: "#fff3e6",
                borderRadius: "8px",
                border: "1px solid #ffe0c2",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
              }}
            >
              <Typography sx={{ fontWeight: 600, color: "#d97706" }}>
                Total Events
              </Typography>
              <Typography sx={{ color: "#444", fontSize: "1.2rem", fontWeight: 700 }}>
                {subProgram.events || 28}
              </Typography>
            </Box>


          </Box>
        </Box>
        <MediaDocumentsTabs />
      </Box >
    </>
  );
};

export default SingleProgDetails;
